// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  listingId: __t.u64().primaryKey().name("listing_id"),
  seller: __t.identity(),
  assetId: __t.u64().name("asset_id"),
  priceSov: __t.i64().name("price_sov"),
  active: __t.bool(),
  listedAt: __t.timestamp().name("listed_at"),
});
